/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import request from '../api';
import useConnectionContext from './useConnectionContext';
import { productsCode } from './useProductsContext';

const { EDD, RA } = productsCode || {};

const ApplicationContext = React.createContext();

const useApplicationContext = () => React.useContext(ApplicationContext);

export const ApplicationProvider = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState({});
  const { isLoading: isConnectionPendding, merchantId } = useConnectionContext();

  const fetchData = React.useCallback(async () => {
    try {
      const { code, data: { eddOnboardingOptions = {}, raOnboardingOptions = {} }, message } = await request('query-onboarding-options', {
        method: 'POST',
        body: {
          merchantId,
          insuranceProductType: EDD,
        },
      });
      setIsLoading(false);
      const { automaticCalculate } = eddOnboardingOptions || {};
      setData({
        EDD: {
          canUpgrade: automaticCalculate,
          ...eddOnboardingOptions,
        },
        RA: raOnboardingOptions,
      });
      console.log({
        EDD: {
          canUpgrade: automaticCalculate,
          ...eddOnboardingOptions,
        },
        RA: raOnboardingOptions,
      });
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      setData({ EDD: {}, RA: {} });
    }
  }, [merchantId]);

  React.useEffect(() => {
    if (!isConnectionPendding) {
      fetchData();
    }
  }, [isConnectionPendding]);

  const value = React.useMemo(() => ({ isLoading, data }), [isLoading, data]);
  return <ApplicationContext.Provider value={value}>{children}</ApplicationContext.Provider>;
};

export default useApplicationContext;
